import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Footprints, Coffee, Activity, ClipboardList, Trophy, Brain, Users, ShoppingBag, UserPlus, MessageCircle, BookOpen } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import BottomNav from "../components/BottomNav.jsx";

const ACTIONS = [
  { to: "/walk", icon: Footprints, label: "Start Active Walk", color: "#2fbf71", tid: "action-walk" },
  { to: "/passive", icon: Coffee, label: "Start Passive Session", color: "#00B4D8", tid: "action-passive" },
  { to: "/training", icon: Activity, label: "Posture Training", color: "#F59E0B", tid: "action-training" },
  { to: "/checkin", icon: ClipboardList, label: "Daily Check-In", color: "#84cc16", tid: "action-checkin" },
  { to: "/coach", icon: Brain, label: "Chat with AI Coach", color: "#a78bfa", tid: "action-coach" },
  { to: "/challenges", icon: Trophy, label: "Browse Challenges", color: "#F59E0B", tid: "action-challenges" },
  { to: "/community", icon: Users, label: "Community", color: "#00B4D8", tid: "action-community" },
  { to: "/friends", icon: UserPlus, label: "Friends", color: "#2fbf71", tid: "action-friends" },
  { to: "/messages", icon: MessageCircle, label: "Messages", color: "#00B4D8", tid: "action-messages" },
  { to: "/library", icon: BookOpen, label: "Content Library", color: "#a78bfa", tid: "action-library" },
  { to: "/marketplace", icon: ShoppingBag, label: "Marketplace", color: "#2fbf71", tid: "action-marketplace" },
];

export default function ActionCenter() {
  const nav = useNavigate();
  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-28">
        <button onClick={() => nav("/home")} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="action-back">
          <ChevronLeft size={16} /> Home
        </button>
        <h1 className="ps-heading text-3xl font-bold mt-4">Action Center</h1>
        <p className="text-slate-400 text-sm">Quick-start your next move.</p>
        <div className="mt-6 grid grid-cols-2 gap-3">
          {ACTIONS.map((a) => (
            <Link key={a.to} to={a.to} data-testid={a.tid} className="ps-card-elev p-5 flex flex-col gap-3 hover:border-[#2fbf71]/40">
              <div className="w-12 h-12 rounded-2xl bg-[#0e1d2a] flex items-center justify-center" style={{ boxShadow: `0 0 0 1px ${a.color}33` }}>
                <a.icon size={22} color={a.color} />
              </div>
              <div className="font-semibold ps-heading">{a.label}</div>
            </Link>
          ))}
        </div>
      </div>
      <BottomNav />
    </PhoneFrame>
  );
}
